import React from 'react';
import { Mail, MessageSquare, FileText, Briefcase } from 'lucide-react';
export const AdoptAI = () => {
  return <section className="py-20 bg-gradient-to-b from-zinc-950 to-black relative overflow-hidden" data-id="element-22">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(255,255,255,0.02)_0,_transparent_70%)]" data-id="element-23"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-24">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-25">
          <div className="md:w-1/2" data-id="element-26">
            <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light mb-6" data-id="element-27">
              Adopt AI Without{' '}
              <span className="text-white" data-id="element-28">Changing How You Work</span>
            </h2>
            <p className="font-['Space_Grotesk'] text-zinc-300 mb-8 font-light" data-id="element-29">
              No lengthy onboarding or resource-intensive changes in workflows
              needed. Think of our service as an employee with its own
              communication channels that can operate on its own or as a layer
              built into your processes.
            </p>
            <div className="space-y-6" data-id="element-30">
              <div className="flex items-start gap-4" data-id="element-31">
                <Mail size={24} className="text-white mt-1" data-id="element-32" />
                <div data-id="element-33">
                  <h3 className="font-['Playfair_Display'] text-xl mb-2" data-id="element-34">
                    Instant Notifications
                  </h3>
                  <p className="font-['Space_Grotesk'] text-zinc-400 font-light" data-id="element-35">
                    After every conversation, you're notified by email or
                    text—just like you would be with an employee.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-36">
                <MessageSquare size={24} className="text-white mt-1" data-id="element-37" />
                <div data-id="element-38">
                  <h3 className="font-['Playfair_Display'] text-xl mb-2" data-id="element-39">
                    Detailed Summaries
                  </h3>
                  <p className="font-['Space_Grotesk'] text-zinc-400 font-light" data-id="element-40">
                    Each interaction includes a concise summary with client
                    details, incident information, and actions taken.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-41">
                <FileText size={24} className="text-white mt-1" data-id="element-42" />
                <div data-id="element-43">
                  <h3 className="font-['Playfair_Display'] text-xl mb-2" data-id="element-44">
                    Complete Transcripts
                  </h3>
                  <p className="font-['Space_Grotesk'] text-zinc-400 font-light" data-id="element-45">
                    Full conversation transcripts provide transparency and
                    context for every client interaction.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-46">
                <Briefcase size={24} className="text-white mt-1" data-id="element-47" />
                <div data-id="element-48">
                  <h3 className="font-['Playfair_Display'] text-xl mb-2" data-id="element-49">
                    Seamless Handoff
                  </h3>
                  <p className="font-['Space_Grotesk'] text-zinc-400 font-light" data-id="element-50">
                    When needed, our system passes leads to your team with all
                    relevant information already collected.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="md:w-1/2" data-id="element-51">
            <div className="relative max-w-md mx-auto" data-id="element-52">
              <div className="absolute inset-0 bg-gradient-to-tr from-zinc-800/30 to-zinc-900/30 rounded-sm backdrop-blur-sm" data-id="element-53"></div>
              <div className="border border-white/20 rounded-sm overflow-hidden relative" data-id="element-54">
                <div className="bg-zinc-900 px-4 py-3 border-b border-white/10 flex items-center" data-id="element-55">
                  <div className="w-3 h-3 rounded-full bg-zinc-700 mr-2" data-id="element-56"></div>
                  <div className="w-3 h-3 rounded-full bg-zinc-700 mr-2" data-id="element-57"></div>
                  <div className="w-3 h-3 rounded-full bg-zinc-700" data-id="element-58"></div>
                  <p className="ml-4 text-zinc-400 text-sm font-['Space_Grotesk']" data-id="element-59">
                    Notification By Email
                  </p>
                </div>
                <div className="p-2 bg-black/80" data-id="element-60">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1zttaWGf2V5stiDt5FoRxV/1000010035.png" alt="Email notification showing a detailed client intake summary" className="w-full rounded-sm" style={{
                  maxHeight: '350px',
                  width: 'auto',
                  objectFit: 'contain',
                  margin: '0 auto'
                }} data-id="element-61" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};